function closeDropdown($dropdown = null) {
  if ($dropdown === null) {
    // just close all dropdowns
    $('.drop-down').each(function () {
      if ($(this).find('.selector').hasClass('selector-open')) {
        $(this).find('.drop-down-list').stop().slideUp(200);
        $(this).find('.selector').removeClass('selector-open');
      }
    });
  } else {
    // check if not already closed
    if (!$dropdown.hasClass('drop-closing')) {
      if ($dropdown.find('.selector').hasClass('selector-open')) {
        $dropdown.addClass('drop-closing');
        $dropdown.find('.drop-down-list').stop().slideUp(200, function () {
          $dropdown.removeClass('drop-closing');
        });
        $dropdown.find('.selector').removeClass('selector-open');
      }
    }
  }
}

function selectSelected($item, $dropdown) {
  $dropdown.find('.drop-down-list .drop-down-item').show();
  $item.hide();
  $dropdown.find('.selector span').html($item.html());
}

// close menu
$(document).on('click', function () {
  closeDropdown();
});

// accessibility
$(document).on('keydown', function (e) {
  // esc
  if (e.keyCode == 27) {
    closeDropdown();
  }
});

var methods = {
  init: function (options, callback) {
    const $selectEl = this;
    $selectEl.hide();

    // get the list
    let selectItems = [];
    this.find('option').each(function () {
      selectItems.push([this.value, this.text]);
    });

    const dropId = Math.ceil(Math.random() * 1000);

    // get the first item
    const firstItem = selectItems[0];

    // create the dropdown
    if (firstItem) {
      this.parent().append(`<div class="drop-down drop-theme-primary" data-dropdown-id="${dropId}" tabindex="0"><div class="selector"><span>${firstItem[1]}</span></div><ul class="drop-down-list"></ul></div>`);
      const $dropdown = $(`[data-dropdown-id="${dropId}"]`);
      const $dropSelector = $dropdown.find('.selector');
      const $dropList = $dropdown.find('.drop-down-list');

      // create the list
      selectItems.forEach(function (item, index) {
        const key = item[0];
        const value = item[1];
        if (index === 0) // first item
          $dropList.append(`<li class="drop-down-item" style="display: none;" data-dropdown-item="${key}" tabindex="0">${value}</li>`);
        else
          $dropList.append(`<li class="drop-down-item" data-dropdown-item="${key}" tabindex="0">${value}</li>`);
      });

      $dropList.hide();

      // list toggle
      $dropdown.on('click', function (e) {
        e.stopPropagation();
        closeDropdown();

        if ($dropList.is(':visible')) {
          closeDropdown($dropdown);
        } else {
          $dropList.stop().slideDown(200);
          $dropSelector.addClass('selector-open');
        }
      });

      // accessibility
      $dropdown.on('keydown', function (e) {
        if (e.keyCode == 13 || e.keyCode == 32) {
          e.stopPropagation();
          e.preventDefault();
          closeDropdown();

          if ($dropList.is(':visible')) {
            closeDropdown($dropdown);
          } else {
            $dropList.stop().slideDown(200);
            $dropSelector.addClass('selector-open');
          }
        }
      });


      // on item click
      $dropList.find('.drop-down-item').on('click', function () {
        const $dropDownItem = $(this);
        closeDropdown();

        $selectEl.val($dropDownItem.data('dropdown-item')).change();
        selectSelected($dropDownItem, $dropdown);

        if (typeof callback == 'function') {
          callback({
            value: $dropDownItem.data('dropdown-item'),
            text: $dropDownItem.html(),
          });
        }
      });

      // accessibility
      $dropList.find('.drop-down-item').on('keydown', function (e) {
        if (e.keyCode == 13 || e.keyCode == 32) {
          e.stopPropagation();
          e.preventDefault();

          const $dropDownItem = $(this);
          closeDropdown();

          $selectEl.val($dropDownItem.data('dropdown-item')).change();
          selectSelected($dropDownItem, $dropdown);

          if (typeof callback == 'function') {
            callback({
              value: $dropDownItem.data('dropdown-item'),
              text: $dropDownItem.html(),
            });
          }
        }
      });
    }

    return this;
  },
};

$.fn.customSelect = function (methodOrOptions) {
  if (methods[methodOrOptions]) {
    return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
  } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
    // Default to "init"
    return methods.init.apply(this, arguments);
  } else {
    $.error('Method ' + methodOrOptions + ' does not exist on jQuery.countTo');
  }
};




// WEBPACK FOOTER //
// ./scripts/util/customSelect.js